export enum ConditionFailReason {
  ConfigurationError,
  CriteriaFail,
  ServerError
}
